import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AllocationViewOrientation, Contact, UnallocatedUserId } from '@jms/model';

@Component({
    selector: 'resource',
    templateUrl: './resource.component.html',
    styleUrls: ['./resource.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ResourceComponent implements OnInit {

    @Input() public resource: Contact;
    @Input() public timezone: string;
    @Input() public isRecommendation: boolean;
    @HostBinding('class') @Input() public orientation = AllocationViewOrientation.Horizontal;

    public unallocatedId = UnallocatedUserId;

    constructor() { }

    public ngOnInit(): void { }

}
